import { render, staticRenderFns } from "./MarketPlaceSoldNA.vue?vue&type=template&id=000d06f8"
import script from "./MarketPlaceSoldNA.vue?vue&type=script&lang=js"
export * from "./MarketPlaceSoldNA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports